import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { Router } from "@angular/router";
import { Countries } from "../../utility/modals";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  
  baseproperties: Baseproperties = new Baseproperties(); 

    private baseURL = this.baseproperties.gatewayBaseURL+"/common"
    scrollHeight: string = '22em'; 
    constructor(private httpClient: HttpClient,private route:Router) { }

  
  getOptionDropdown(length):Array<any>{
    let options=[]
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e)=>{
      options.push({'label':e[0],value:e[0]})
    });
    return options
  }
  
  //Add New Country
  addCountry(country): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/country/addcountry`, country);
  }
  getCountryById(id: number, number: any): Observable<Countries>{
    return this.httpClient.get<Countries>(`${this.baseURL}/country/getcountrybyid/${id}`);
  }
  updateCountry(country: Countries): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/country/modifycountry`, country);
    }
    getCountryData(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/country/getallcountries`);
      }
      countryDataExcel()
  {
    
     return this.httpClient.get(`${this.baseURL}/country/countrydataexcel`,{ responseType: 'blob' }); 
  }
}


